// Disabling File System Storage for now
export const hasFileStorage = false;
// typeof window !== 'undefined'
//   && 'storage' in navigator
//   && 'getDirectory' in navigator.storage;
